import type { EventName } from "@lit/react";
import { GridSorter as GridSorterElement, type GridSorterEventMap as _GridSorterEventMap, } from "@vaadin/grid/vaadin-grid-sorter.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { GridSorterElement, };
export type GridSorterEventMap = Readonly<{
    onDirectionChanged: EventName<_GridSorterEventMap["direction-changed"]>;
    onSorterChanged: EventName<_GridSorterEventMap["sorter-changed"]>;
}>;
const events = { onDirectionChanged: "direction-changed", onSorterChanged: "sorter-changed" } as GridSorterEventMap;
export type GridSorterProps = WebComponentProps<GridSorterElement, GridSorterEventMap>;
export const GridSorter = createComponent({
    elementClass: GridSorterElement, events, react: React, tagName: "vaadin-grid-sorter"
});
